export { PrizeWithCheckMark } from "./PrizeWithCheckMark";
